import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPermissions } from "store/actions/roleAction";

const Permission = ({ resources, children, message = "" }) => {
  const dispatch = useDispatch();
  const permissions = useSelector(state => state.role.getPermissions);
  const [authorized, setAuthorized] = useState(null);

  useEffect(() => {
    if (!permissions) {
      dispatch(getPermissions());
    }
  }, [permissions, dispatch]);

  useEffect(() => {
    if (authorized === null && permissions) {
      // Check if the user is authorized
      resources.forEach(resource => {
        if (![].concat(permissions).includes(resource)) {
          setAuthorized(false);
          return;
        }
        setAuthorized(true);
      });
    }
  }, [authorized, permissions, resources]);

  return (
    <>
      {authorized ? (
        children
      ) : (
        <div className="alert alert-warning center">
          {message || "You do not have permission to view this page."}
        </div>
      )}
    </>
  );
};

export default Permission;
